import { Paper } from 'components';
import React from 'react';
import titlePNG from 'assets/images/title.png';
import titleMobilePNG from 'assets/images/title_mobile.png';

const Intro = () => (
  <Paper
    data-testid="intro"
    className="intro ml-auto bottom-0 absolute w-full h-full right-0"
  >
    <picture className="block h-full w-full">
      <source media="(max-width: 639px)" srcSet={titleMobilePNG} />
      <img
        className="h-full w-full object-contain p-2"
        src={titlePNG}
        alt="Fahrschule Untern Buchen"
      />
    </picture>
  </Paper>
);

export default Intro;
